jQuery( function($){
    jQuery.validator.addMethod('alphabetic', function(value, element) {
        return this.optional(element) || /^[a-z\s]+$/i.test(value);
    }, 'Ingresar solo letras');
    var $form = $('form.wpcf7-form');
    $form.validate({
        rules : {
            nombre : {required : true, alphabetic: true },
            correo : {required : true, email : true },
            telefono : { digits: true },
        },
        messages : {
            nombre : {
                required : 'Este campo es obligatorio',
                alphabetic : 'Debes ingresar solo letras'
            },

            correo: {
                required : 'Este campo es obligatorio' ,
                email:'Ingresa un correo válido'
            },

            telefono : {
                digits: 'Debes ingresar solo dígitos'
            },
        },

        errorPlacement : function($error, $element){
            $element.closest('form.wpcf7-form .wpcf7-form-control-wrap').append($error);
        },

        // función que se ejecutará al enviar
        submitHandler : function(form){

        }
    });
});
